import React from "react";
import EmailLayout from "./EmailLayout";
import { Trans } from "react-i18next";

const pStyle = {
  margin: "0px 0px 15px",
  fontFamily: "sans-serif",
  fontSize: 14,
  fontWeight: "normal",
};

// "refunded": cancelled outside the cutoff and a real charge was refunded/voided.
// "noRefund": cancelled within the cutoff on a booking that had been charged.
// "notCharged": booking was never actually charged (still pending/pre-auth
//   only) — there's nothing to refund regardless of timing, and the copy
//   shouldn't imply this was a within-cutoff policy denial.
const STATUS_KEYS = {
  refunded: {
    header: "headerWithRefund",
    message: "messageWithRefund",
    refundStatus: "refundApproved",
    noticeTitle: "refundNoticeTitle",
    notice: "refundNotice",
    closing: "closingWithRefund",
  },
  noRefund: {
    header: "headerNoRefund",
    message: "messageNoRefund",
    refundStatus: "noRefund",
    noticeTitle: "noRefundTitle",
    notice: "noRefundNotice",
    closing: "closingNoRefund",
  },
  notCharged: {
    header: "headerNoRefund",
    message: "messageNoRefund",
    refundStatus: "noChargeMade",
    noticeTitle: "noChargeTitle",
    notice: "noChargeNotice",
    closing: "closingNoRefund",
  },
};

class BookingCancelled extends React.Component {
  render() {
    const { t, name, examTitle, bookingDate, timezone, duration, status, refundAmount } =
      this.props;
    const keys = STATUS_KEYS[status] || STATUS_KEYS.noRefund;
    const refunded = status === "refunded";

    return (
      <EmailLayout
        t={t}
        content={[
          <h2 key="header">{t(`Emails.BookingCancelled.${keys.header}`)}</h2>,
          <p key="greeting" style={pStyle}>
            {name},
          </p>,
          <p key="message" style={pStyle}>
            <Trans t={t} i18nKey={`Emails.BookingCancelled.${keys.message}`}>
              Your booking for {{ examTitle }} scheduled for {{ bookingDate }} {{ timezone }} has been successfully cancelled.
            </Trans>
          </p>,
          <p key="details" style={pStyle}>
            <strong>{t("Emails.BookingCancelled.cancellationDetails")}:</strong>
          </p>,
          <p key="exam" style={pStyle}>
            <Trans t={t} i18nKey="Emails.BookingCancelled.examName">
              Exam Name
            </Trans>
            : {examTitle}
          </p>,
          <p key="date" style={pStyle}>
            <Trans t={t} i18nKey="Emails.BookingCancelled.scheduledDate">
              Scheduled Date & Time
            </Trans>
            : {bookingDate} {timezone}
          </p>,
          <p key="duration" style={pStyle}>
            <Trans t={t} i18nKey="Emails.BookingCancelled.duration">
              Duration
            </Trans>
            : {duration} {t("general.hours")}
          </p>,
          <p key="refund-status" style={pStyle}>
            <Trans t={t} i18nKey="Emails.BookingCancelled.refundStatus">
              Refund Status
            </Trans>
            : {t(`Emails.BookingCancelled.${keys.refundStatus}`)}
          </p>,
          refunded && refundAmount && (
            <p key="refund-amount" style={pStyle}>
              <Trans t={t} i18nKey="Emails.BookingCancelled.refundAmount">
                Refund Amount
              </Trans>
              : ${refundAmount}
            </p>
          ),
          <p key="notice" style={pStyle}>
            <strong>{t(`Emails.BookingCancelled.${keys.noticeTitle}`)}:</strong>
            <br />
            {t(`Emails.BookingCancelled.${keys.notice}`)}
          </p>,
          <p key="closing" style={pStyle}>
            {t(`Emails.BookingCancelled.${keys.closing}`)}
          </p>,
          <p key="questions" style={pStyle}>
            {t("Emails.BookingCancelled.questions")}
          </p>,
        ]}
      />
    );
  }
}

export default BookingCancelled;
